import React, {useRef, useEffect} from 'react';
import {Animated} from 'react-native';
import {RFValue} from 'react-native-responsive-fontsize';
import {
  Container,
  Limit,
  LimitTitle,
  LimitsTextContainer,
  Progress,
  ProgressBarContainer,
} from './styles';
import {useTheme} from 'styled-components/native';

interface Props {
  maxPercentage: number;
  percentage: number;
  title?: string;
  suffix?: string;
  successBar?: boolean;
}

export function ProgressBar({
  maxPercentage,
  successBar,
  percentage,
  title,
  suffix,
}: Props) {
  const theme = useTheme();
  const progress = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    Animated.timing(progress, {
      toValue: percentage,
      duration: 300, // Duração da animação em milissegundos
      useNativeDriver: false,
    }).start();
  }, [percentage, progress]);

  const animatedWidth = progress.interpolate({
    inputRange: [0, maxPercentage],
    outputRange: ['0%', '99%'],
    extrapolate: 'clamp',
  });

  return (
    <Container>
      {title && <LimitTitle>{title}</LimitTitle>}

      <ProgressBarContainer>
        <Progress
          style={{
            width: animatedWidth,
            backgroundColor:
              percentage >= maxPercentage
                ? successBar
                  ? theme.colors.primary
                  : theme.colors.red
                : theme.colors.blue,
            borderTopRightRadius: percentage >= maxPercentage ? RFValue(6) : 0,
            borderBottomRightRadius:
              percentage >= maxPercentage ? RFValue(6) : 0,
          }}
        />
      </ProgressBarContainer>
      <LimitsTextContainer>
        <Limit>
          {maxPercentage - percentage}
          {suffix ? ' ' + suffix : ''}
        </Limit>
        <Limit>
          {maxPercentage}
          {suffix ? ' ' + suffix : ''}
        </Limit>
      </LimitsTextContainer>
    </Container>
  );
}
